import ErrorIcon from 'images/v2/icons/svg/fill/svg/error.svg';
import YellowExclamationIcon from 'assets/images/icons/toast/info.svg';
import RedExclamationIcon from 'assets/images/icons/status/step/attention.svg';
import { ReactNode } from 'react';
import { ToastContainer, ToastOptions, toast } from 'react-toastify';
import styled from 'styled-components';

type TProps = {
  severity?: 'success' | 'warning' | 'yellow-exclamation-warning' | 'info' | 'error' | 'red-exclamation-error';
  summary?: string | undefined | ReactNode;
  details?: string | undefined | ReactNode;
  options?: ToastOptions;
};

const ToastTemplate = ({ summary, details }: TProps) => {
  return (
    <Container>
      <SummaryText>{summary}</SummaryText>
      {details && <DetailsText>{details}</DetailsText>}
    </Container>
  );
};

export const toaster = ({ severity, summary, details, options }: TProps) => {
  switch (severity) {
    case 'success':
      return toast.success(<ToastTemplate summary={summary} details={details} />, options);
    case 'warning':
      return toast.warning(<ToastTemplate summary={summary} details={details} />, options );
    case 'yellow-exclamation-warning':
      return toast.error(<ToastTemplate summary={summary} details={details} />, {
        icon: <img src={YellowExclamationIcon} alt="Warning" />, ...options
      });
    case 'info':
      return toast.info(<ToastTemplate summary={summary} details={details} />);
    case 'error':
      return toast.error(<ToastTemplate summary={summary} details={details} />, {
        icon: <img src={ErrorIcon} alt="Error" />, ...options 
      });
    case 'red-exclamation-error':
      return toast.error(<ToastTemplate summary={summary} details={details} />, {
        icon: <img src={RedExclamationIcon} style={{ width: 20, height: 20 }} alt="Error" />,
      ...options});
    default:
      return toast.success(<ToastTemplate summary={summary} details={details} />, options);
  }
};

const Container = styled.div`
  font-family: Inter;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    width: fit-content;
    padding: 0;
  }
  .Toastify__toast {
    color: #151515;
    font-size: 14px;
    padding: 15px 20px;
    min-height: 50px !important;
  }
  .Toastify__toast-body {
    padding: 0;
    margin-right: 30px;
  }
  .Toastify__close-button--light {
    width: 16px;
    opacity: 1;
  }
`;

const SummaryText = styled.b`
  font-weight: 600;
  display: block;
  line-height: 1.4;
  margin: 0;
`;

const DetailsText = styled.div`
  color: rgba(0, 0, 0, 0.7);
  line-height: 1.4;
  margin-top: 10px;

  & a {
    color: ${(props) => props.theme.colors.primaryOrange};
  }
`;

export const ApplicationToastRoot = () => {
  return (
    <StyledToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  );
};
